
import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import CalendarPage from './pages/Calendar';
import CreateQuote from './pages/CreateQuote';
import AllBookings from './pages/AllBookings';
import { SIDEBAR_ITEMS } from './constants';

const ContentWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const currentItem = SIDEBAR_ITEMS.find(item => item.path === location.pathname);
  const title = currentItem ? currentItem.label : 'TravelBook';

  return (
    <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
      <Header title={title} />
      <main className="flex-1 overflow-y-auto custom-scrollbar bg-slate-50 dark:bg-slate-950/50">
        {children}
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="flex min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-200">
        <Sidebar />
        <ContentWrapper>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/create-quote" element={<CreateQuote />} />
            <Route path="/my-quotes" element={<AllBookings />} />
            <Route path="/all-bookings" element={<AllBookings />} />
            {/* Fallback routes for demo */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </ContentWrapper>
      </div>
    </Router>
  );
}

export default App;
